var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0l2.793 2.793L3.586 7 5 8.414l4.207-4.207L12 7V0H5z",
    fill: "#635F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0H0v10a2 2 0 002 2h10v-2H2V0z",
    fill: "#635F6F"
  })));
}

export default SvgExport;